/* Progressive enhancement: Shopify forms remain native. No third-party runtime. */
(() => {
  const initMenu = (root = document) => {
    root.querySelectorAll('[data-menu-open]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog) return;
      button.addEventListener('click', () => { if(!dialog.open) dialog.showModal(); button.setAttribute('aria-expanded', 'true'); });
      dialog.querySelector('[data-menu-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right) dialog.close(); } });
      dialog.addEventListener('click', event => { if(event.target.closest('a[href]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) dialog.close(); });
      dialog.addEventListener('close', () => { button.setAttribute('aria-expanded', 'false'); if(button.isConnected){const target=button.getClientRects().length?button:button.closest('header').querySelector('.brand');target.focus({preventScroll:true});} });
    });
  };
  initMenu();
  document.addEventListener('shopify:section:load', event => initMenu(event.target));
  // Native details preserve keyboard and no-JavaScript navigation.
  const navigationStates = new Map();
  const initNavigation = (root = document) => {
    const headers = [...root.querySelectorAll('[data-navigation-header]')];
    if(root.matches?.('[data-navigation-header]')) headers.unshift(root);
    headers.forEach(header => {
      if(navigationStates.has(header)) return;
      const controller = new AbortController();
      const options = {signal:controller.signal};
      const desktop = header.querySelector('.desktop-nav');
      const groups = [...desktop.querySelectorAll('[data-desktop-dropdown]')];
      const close = group => { group.open=false; group.querySelector('summary').setAttribute('aria-expanded','false'); };
      const closeAll = except => groups.forEach(group => { if(group!==except) close(group); });
      const place = group => {
        const panel=group.querySelector('.nav-dropdown');
        panel.classList.remove('align-right');
        if(panel.getBoundingClientRect().right>innerWidth-16) panel.classList.add('align-right');
      };
      groups.forEach(group => {
        const summary=group.querySelector('summary');
        let keyboardMode=false;
        let openedByHover=false;
        summary.setAttribute('aria-expanded',String(group.open));
        group.addEventListener('toggle',()=>{summary.setAttribute('aria-expanded',String(group.open));if(group.open){closeAll(group);place(group);}},options);
        group.addEventListener('pointerenter',event=>{if(event.pointerType!=='mouse'||!matchMedia('(hover: hover)').matches)return;keyboardMode=false;openedByHover=!group.open;closeAll(group);group.open=true;summary.setAttribute('aria-expanded','true');place(group);},options);
        group.addEventListener('pointerleave',()=>{openedByHover=false;if(!keyboardMode||!group.contains(document.activeElement))close(group);},options);
        group.addEventListener('keydown',event=>{keyboardMode=true;if(event.key==='Escape'&&group.open){event.preventDefault();event.stopPropagation();close(group);summary.focus({preventScroll:true});}},options);
        group.addEventListener('focusout',event=>{
          if(event.relatedTarget&&group.contains(event.relatedTarget))return;
          setTimeout(()=>{if(!controller.signal.aborted&&!group.contains(document.activeElement))close(group);},0);
        },options);
        summary.addEventListener('click',event=>{if(event.detail>0){keyboardMode=false;if(openedByHover&&group.open)event.preventDefault();openedByHover=false;}},options);
      });
      document.addEventListener('pointerdown',event=>{if(!desktop.contains(event.target))closeAll();},options);
      document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!event.defaultPrevented&&!header.querySelector('[data-mobile-menu]').open){const open=groups.find(group=>group.open);if(open){event.preventDefault();close(open);open.querySelector('summary').focus({preventScroll:true});}}},options);
      desktop.addEventListener('keydown',event=>{if(event.key==='Escape'){const open=groups.find(group=>group.open);if(open){event.preventDefault();close(open);open.querySelector('summary').focus({preventScroll:true});}}},options);
      const fit = () => {
        header.classList.remove('header-compact');
        if(!matchMedia('(min-width:1200px)').matches){closeAll();return;}
        const inner=header.querySelector('.header-inner');
        const needed=desktop.scrollWidth+header.querySelector('.brand').getBoundingClientRect().width+header.querySelector('.header-actions').getBoundingClientRect().width+48;
        if(needed>inner.clientWidth){header.classList.add('header-compact');closeAll();}
        const dialog=header.querySelector('[data-mobile-menu]');
        if(!header.classList.contains('header-compact')&&dialog.open)dialog.close();
      };
      const observer='ResizeObserver' in window ? new ResizeObserver(fit) : null;
      if(observer) observer.observe(header.querySelector('.header-inner')); else window.addEventListener('resize',fit,options);
      fit();navigationStates.set(header,{controller,observer});
    });
  };
  initNavigation();
  document.addEventListener('shopify:section:load',event=>initNavigation(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    navigationStates.forEach((state,header)=>{if(event.target.contains(header)){header.querySelector('[data-mobile-menu]')?.close();state.controller.abort();state.observer?.disconnect();navigationStates.delete(header);}});
  });
  let variantRequest;
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-option-value]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const section = link.closest('[data-product-section]');
    const destination = new URL(link.href);
    // Combined listing siblings use their native product URL.
    if (destination.pathname !== location.pathname) return;
    event.preventDefault();
    variantRequest?.abort();
    const request = new AbortController(); variantRequest = request;
    const quantity = section.querySelector('[name="quantity"]')?.value;
    const optionId = link.dataset.optionValue;
    const message = section.querySelector('.variant-message');
    section.setAttribute('aria-busy', 'true');
    message.textContent = section.dataset.loading;
    const submit = section.querySelector('[name="add"]');
    if (submit) submit.disabled = true;
    const variantInput = section.querySelector('[name="id"]');
    if (variantInput) variantInput.disabled = true;
    // Never leave the previous option's Amazon URL active during a request or failure.
    const amazonButton = section.querySelector('[data-amazon-purchase]');
    if (amazonButton) { amazonButton.removeAttribute('href'); amazonButton.setAttribute('aria-disabled', 'true'); }
    destination.searchParams.set('section_id', section.dataset.sectionId);
    try {
      const response = await fetch(destination, {signal: request.signal});
      if (!response.ok) throw new Error('Section request failed');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = parsed.querySelector('[data-product-section]');
      if (!replacement) throw new Error('Missing product section');
      const input = replacement.querySelector('[name="quantity"]');
      if (input && quantity) { const min = Number(input.min)||1; const max = Number(input.max)||Infinity; const step = Number(input.step)||1; input.value = String(Math.min(max, min+Math.max(0,Math.floor((Number(quantity)-min)/step))*step)); }
      section.replaceWith(replacement);
      destination.searchParams.delete('section_id'); history.replaceState({}, '', destination);
      replacement.querySelector(`[data-option-value="${CSS.escape(optionId)}"]`)?.focus({preventScroll:true});
    } catch (error) {
      if (error.name === 'AbortError') return;
      // Selected controls no longer match the old variant: prevent accidental old-variant purchase.
      message.textContent = section.dataset.error;
      const retry = document.createElement('a'); retry.href = link.href; retry.textContent = ' Reload selection'; message.append(retry);
      if (submit) submit.disabled = true; if (variantInput) variantInput.disabled = true;
    } finally {
      if (variantRequest === request) section.removeAttribute('aria-busy');
    }
  });
  const initRecommendations = (root = document) => {
    root.querySelectorAll('[data-recommendations]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const load = async () => {
        try { const response = await fetch(section.dataset.url); if(!response.ok) return; const page = new DOMParser().parseFromString(await response.text(),'text/html'); const content = page.querySelector('[data-recommendations]'); if(content) section.innerHTML = content.innerHTML; } catch { /* Optional recommendations must never block purchasing. */ }
      };
      if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if(entries.some(e=>e.isIntersecting)) { observer.disconnect(); load(); } }, {rootMargin:'300px'}); observer.observe(section); } else load();
    });
  };
  initRecommendations();
  document.addEventListener('shopify:section:load', event => initRecommendations(event.target));
  const initGuides = (root = document) => {
    root.querySelectorAll('[data-guide-filter]').forEach(filter => {
      if(filter.dataset.initialized) return;
      filter.dataset.initialized = 'true'; filter.hidden = false;
      const select = filter.querySelector('[data-guide-select]');
      const cards = filter.parentElement.querySelectorAll('[data-guide-model]');
      const categorySelect = filter.querySelector('[data-guide-category-select]');
      const groups = filter.parentElement.querySelectorAll('[data-guide-group]');
      const update = () => {
        let count=0;
        cards.forEach(card => { card.hidden = Boolean((select.value && card.dataset.guideModel !== select.value) || (categorySelect?.value && card.dataset.guideCategory !== categorySelect.value)); if(!card.hidden) count++; });
        groups.forEach(group => { group.hidden = Boolean((categorySelect?.value && group.dataset.guideGroup !== categorySelect.value) || (select.value && !group.querySelector('[data-guide-model]:not([hidden])'))); });
        filter.querySelector('[data-guide-status]').textContent = count ? `${count} guide${count===1?'':'s'}` : 'No published guides match your selection.';
      };
      select.addEventListener('change', update); categorySelect?.addEventListener('change', update); update();
    });
  };
  initGuides();
  document.addEventListener('shopify:section:load', event => initGuides(event.target));
  // Download only on explicit interaction; preview links remain native and work without JavaScript.
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-manual-download]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!window.fetch || !window.URL?.createObjectURL) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const status = link.parentElement.querySelector('.manual-download-status');
    link.setAttribute('aria-busy', 'true');
    status.textContent = 'Preparing PDF download…';
    try {
      const response = await fetch(link.href);
      if (!response.ok) throw new Error('PDF download failed');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const download = document.createElement('a');
      download.href = url; download.download = new URL(link.href).pathname.split('/').pop() || 'atorpok-manual.pdf';
      document.body.append(download); download.click(); download.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      status.textContent = 'PDF download started.';
    } catch {
      status.replaceChildren('Download could not start. ');
      const fallback = document.createElement('a');
      fallback.href = link.href; fallback.target = '_blank'; fallback.rel = 'noopener noreferrer';
      fallback.textContent = 'Open the PDF and use your browser’s download control.';
      status.append(fallback);
    } finally { link.removeAttribute('aria-busy'); }
  });
  document.addEventListener('submit', event => {
    const section = event.target.closest('[data-product-section]');
    if (section && (section.getAttribute('aria-busy') === 'true' || section.querySelector('[name="id"]')?.disabled)) event.preventDefault();
  });
})();
